import * as _ from 'lodash'
import axios from 'axios'
import {
  ILoaderService,
  ILoaderStartOptions,
  ILoaderStartStopResponse,
  ILoaderStatus
} from "../PA.Loader.Core/PA.Loader.IF.Aspects";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


export interface ILoaderServiceRequest {
  requestType: string,
  wbLoaderId?: number,
  options?: any
}

export interface ILoaderServiceResponse {
  request: ILoaderServiceRequest,
  bSucess: boolean,
  sErrors: string[],
  sWarnings: string[],
  results: any
}

export class Loader
  implements ILoaderService
{
  constructor(){

  }

  startLoader(aWB_Loader_ID: number, options?: ILoaderStartOptions): Promise<ILoaderStartStopResponse> {
    return Loader.makeRequest("startLoader", aWB_Loader_ID,options || {});
  }

  stopLoader(aWB_Loader_ID: number): Promise<ILoaderStartStopResponse> {
    return Loader.makeRequest("stopLoader", aWB_Loader_ID, {});
  }

  getLoaderStatus(aWB_Loader_ID: number): Promise<ILoaderStatus> {
    return Loader.makeRequest("getLoaderStatus", aWB_Loader_ID, {});
  }

  private static makeRequest(requestType: string,
                             wbLoaderId?: number,
                             options?: any): Promise<any>
  {
    return new Promise<any[]>((resolve, error) => {


      let loaderRequest: ILoaderServiceRequest = {
        requestType: requestType
      }

      if(wbLoaderId)
        loaderRequest.wbLoaderId = wbLoaderId



      if(options)
        loaderRequest.options = options

      let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
      if(sEndPoint.endsWith('/'))
        sEndPoint += 'loader';
      else
        sEndPoint += '/loader';

      axios.post(sEndPoint, {data: {request: loaderRequest}})
        .then((resp: any) => {
          let responseData: ILoaderServiceResponse = resp.data;
          if('request' in responseData) {
            if(!responseData.bSucess){
              error("Loader Service Response: " + (responseData.sErrors || ['Unknown']).toString())
            } else {
              resolve(responseData.results)
            }
          } else {
            error('Unable to parse Loader Web Response: ' + responseData );
          }
        })
        .catch((err:any) => {
          error('Unable to obtain Loader Results from Server. ' + err);
        });
    });
  }

}

